const SCRIPT_ID = "salesforce-embedded-messaging";
console.log("SalesforceEmbeddedMessaging module loaded");
export const bootstrapSalesforce = (orgId, embeddedMessagingName, baseUrl, scrt2Url, language = "en_US", username) => {
    console.log("Bootstrapping Salesforce Embedded Messaging with", {
        orgId,
        embeddedMessagingName,
        baseUrl,
        scrt2Url,
        language,
        username
    });
    const missing = [
        !orgId && "orgId",
        !embeddedMessagingName && "embeddedMessagingName",
        !baseUrl && "baseUrl",
        !scrt2Url && "scrt2Url"
    ].filter(Boolean);
    if (missing.length) {
        console.error("Salesforce chat config missing: " + missing.join(", "));
        return;
    }
    if (window["embeddedservice_bootstrap"])
        return;
    if (document.getElementById(SCRIPT_ID))
        return;
    if (username) {
        window.addEventListener("onEmbeddedMessagingReady", () => {
            try {
                window["embeddedservice_bootstrap"]?.prechatAPI?.setHiddenPrechatFields({
                    Dploy_Username: username
                });
            }
            catch (err) {
                console.error("Salesforce Embedded Messaging setHiddenPrechatFields failed", err);
            }
        });
    }
    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.type = "text/javascript";
    s.src = baseUrl.replace(/\/$/, "") + "/assets/js/bootstrap.min.js";
    s.setAttribute("data-cookieconsent", "functional");
    s.onload = () => {
        try {
            if (!window["embeddedservice_bootstrap"])
                return;
            window["embeddedservice_bootstrap"].settings.language = language;
            window["embeddedservice_bootstrap"].init(orgId, embeddedMessagingName, baseUrl, { scrt2URL: scrt2Url });
        }
        catch (err) {
            console.error("Salesforce Embedded Messaging init failed", err);
        }
    };
    s.onerror = () => {
        console.error("Failed to load Salesforce Embedded Messaging bootstrap");
    };
    const first = document.getElementsByTagName("script")[0];
    first?.parentNode?.insertBefore(s, first);
};
export const clearSalesforce = () => {
    document.getElementById(SCRIPT_ID)?.remove();
};
//# sourceMappingURL=SalesforceEmbeddedMessaging.js.map